/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { ISiteRepository } from '../../domain/repositories/site.repository';
import { GetOneSite } from '../queries/get-one-site';

export namespace UpdateSite {
  export type Input = ISiteRepository.UpdateInput;
  export type Output = ISiteRepository.UpdateOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.site.update(input),
      async onSuccess(_, variables) {
        await queryClient.invalidateQueries({
          queryKey: GetOneSite.key(variables),
        });
      },
    });
  }
}
